import {ListDepartment} from "@/api/department";

const state = () => ({
  departments: []
})

// getters
const getters = {}

// actions
const actions = {
  async fetchDepartments( { commit, dispatch } ) {
    await dispatch("loading/setLoading", true, {root: true})
    ListDepartment().then((data) => {
      let departments = data.data.data
      console.log(departments)
      departmentTree(departments)
      commit('setDepartments', departments)
    }).catch((err) => {
      console.log(err)
    }).finally(async () =>{
      await dispatch("loading/setLoading", false, {root: true})
    })
  },
}

function departmentTree(departments) {
  if (departments !== undefined) {
    for (let department of departments) {
      department.title = department.department_name
      if (department.children) {
        departmentTree(department.children)
      }
    }
  }
}

// mutations
const mutations = {
  setDepartments (state, departments) {
    state.departments = departments
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
